// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Homescreen-box {
  min-height: 100vh;
  background-color: rgba(244, 244, 244, 0.471);
}

.Homescreen-txt1 {
  font-family: "NotoSansMalayalam-Bold";
  padding-bottom: 5px;
  margin-bottom: 5px;
  font-size: 25px;
}

.Head-n {
  font-family: "NotoSansMalayalam-Bold";
  font-size: 25px;
  margin-bottom: 4px;
}

@media (max-width: 768px) {
  .Head-n {
    font-size: 20px; /* Smaller size for mobile */
  }
}
@media (max-width: 768px) {
  .Head-section-m {
    margin-top: 10px; /* Smaller size for mobile */
  }
}
.Head-section-m {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  padding-right: 5px;
}

.Homescreen-viewAll {
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
  cursor: pointer;
}

@media (max-width: 768px) {
  .Homescreen-viewAll {
    font-size: 14px; /* smaller for mobile */
  }
}
.Homescreen-loading {
  height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "NotoSansMalayalam-Regular";
  font-size: 14px;
  color: gray;
}

.Homescreen-item {
  margin-bottom: 20px;
  border: 1px solid rgb(193, 199, 203);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.Homescreen-itemBox {
  padding: 15px;
}

.Homescreen-itemImage {
  width: 100%;
  aspect-ratio: 1/1.4;
}

.Homescreen-itemBox2 {
  padding: 10px;
  text-align: center;
  border-top: 1px solid rgb(5, 118, 183);
  background-color: rgb(5, 118, 183);
  font-family: "NotoSansMalayalam-SemiBold";
  color: #fff;
}

.Homescreen-itemImg {
  width: 100%;
}

.Homescreen-itemImg2 {
  width: 100%;
  height: 170px;
}

.all-back-btn:hover {
  cursor: pointer;
}

.page-text {
  font-family: "NotoSansMalayalam-Regular";
  font-size: 14px;
  color: #000000;
}`, "",{"version":3,"sources":["webpack://./src/screens/NjayarPrabhaathamAll/styles.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,4CAAA;AACF;;AAEA;EACE,qCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AACA;EACE,qCAAA;EACA,eAAA;EACA,kBAAA;AAEF;;AAAA;EACE;IACE,eAAA,EAAA,4BAAA;EAGF;AACF;AADA;EACE;IACE,gBAAA,EAAA,4BAAA;EAGF;AACF;AADA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAGF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,eAAA;AAIF;;AAFA;EACE;IACE,eAAA,EAAA,uBAAA;EAKF;AACF;AAHA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;EACA,WAAA;AAKF;;AAFA;EACE,mBAAA;EACA,oCAAA;EACA,0CAAA;AAKF;;AAFA;EACE,aAAA;AAKF;;AAHA;EACE,WAAA;EACA,mBAAA;AAMF;;AAHA;EACE,aAAA;EACA,kBAAA;EACA,sCAAA;EACA,kCAAA;EACA,yCAAA;EACA,WAAA;AAMF;;AAHA;EACE,WAAA;AAMF;;AAJA;EACE,WAAA;EACA,aAAA;AAOF;;AAJA;EACE,eAAA;AAOF;;AAJA;EACE,wCAAA;EACA,eAAA;EACA,cAAA;AAOF","sourcesContent":[".Homescreen-box {\n  min-height: 100vh;\n  background-color: rgba(244, 244, 244, 0.471);\n}\n\n.Homescreen-txt1 {\n  font-family: \"NotoSansMalayalam-Bold\";\n  padding-bottom: 5px;\n  margin-bottom: 5px;\n  font-size: 25px;\n}\n.Head-n {\n  font-family: \"NotoSansMalayalam-Bold\";\n  font-size: 25px;\n  margin-bottom: 4px;\n}\n@media (max-width: 768px) {\n  .Head-n {\n    font-size: 20px; /* Smaller size for mobile */\n  }\n}\n@media (max-width: 768px) {\n  .Head-section-m {\n    margin-top: 10px; /* Smaller size for mobile */\n  }\n}\n.Head-section-m {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 50px;\n  padding-bottom: 5px;\n  margin-bottom: 5px;\n  padding-right: 5px;\n}\n.Homescreen-viewAll {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  justify-content: center;\n  cursor: pointer;\n}\n@media (max-width: 768px) {\n  .Homescreen-viewAll {\n    font-size: 14px; /* smaller for mobile */\n  }\n}\n.Homescreen-loading {\n  height: 70vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-family: \"NotoSansMalayalam-Regular\";\n  font-size: 14px;\n  color: gray;\n}\n\n.Homescreen-item {\n  margin-bottom: 20px;\n  border: 1px solid rgb(193, 199, 203);\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.Homescreen-itemBox {\n  padding: 15px;\n}\n.Homescreen-itemImage {\n  width: 100%;\n  aspect-ratio: 1/1.4;\n}\n\n.Homescreen-itemBox2 {\n  padding: 10px;\n  text-align: center;\n  border-top: 1px solid rgb(5, 118, 183);\n  background-color: rgb(5, 118, 183);\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  color: #fff;\n}\n\n.Homescreen-itemImg {\n  width: 100%;\n}\n.Homescreen-itemImg2 {\n  width: 100%;\n  height: 170px;\n}\n\n.all-back-btn:hover {\n  cursor: pointer;\n}\n\n.page-text {\n  font-family: \"NotoSansMalayalam-Regular\";\n  font-size: 14px;\n  color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
